/* =============================================================================
   Original Nutrition — theme.js
   Re-implements every interactive behaviour from the source export against
   Shopify's native AJAX endpoints. No framework, no build step.
   ========================================================================== */
(function () {
  'use strict';

  var Routes = window.ONRoutes || {};
  var Strings = window.ONStrings || {};
  var MoneyFormat = window.ONMoneyFormat || '${{amount}}';
  var ThemeSettings = window.ONSettings || { cartDrawer: true };

  /* ---------------------------------------------------------------- helpers */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }

  // The theme editor re-runs boot() on shopify:section:load, so every
  // element-level binding is guarded to stay idempotent.
  var bound = new WeakSet();
  function once(el) {
    if (!el || bound.has(el)) return false;
    bound.add(el);
    return true;
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, size) {
      var s = '' + num;
      while (s.length < size) s = '0' + s;
      return s;
    }
    function thousands(num, sep, dec, decimals) {
      if (isNaN(num) || num === null) return 0;
      num = (num / 100.0).toFixed(decimals);
      var parts = num.split('.');
      var int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
      var cent = parts[1] ? dec + parts[1] : '';
      return int + cent;
    }

    var match = MoneyFormat.match(placeholderRegex);
    var fmt = match ? match[1] : 'amount';
    switch (fmt) {
      case 'amount': value = thousands(cents, ',', '.', 2); break;
      case 'amount_no_decimals': value = thousands(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, '.', ',', 0); break;
      case 'amount_with_space_separator': value = thousands(cents, ' ', ',', 2); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, ' ', ',', 0); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, "'", '.', 2); break;
      default: value = thousands(cents, ',', '.', 2);
    }
    void defaultTo;
    return MoneyFormat.replace(placeholderRegex, value);
  }

  function lockScroll(lock) {
    document.body.classList.toggle('on-no-scroll', !!lock);
  }

  /* ------------------------------------------------------- mobile nav menu */
  function initMobileMenu() {
    var panel = $('[data-mobile-menu]');
    if (!panel) return;

    function open() { panel.hidden = false; lockScroll(true); }
    function close() { panel.hidden = true; lockScroll(false); }

    $$('[data-mobile-menu-open]').forEach(function (btn) { if (once(btn)) on(btn, 'click', open); });
    $$('[data-mobile-menu-close]').forEach(function (btn) { if (once(btn)) on(btn, 'click', close); });

    $$('[data-mobile-submenu-toggle]', panel).forEach(function (btn) {
      on(btn, 'click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (target) target.hidden = expanded;
        var chev = $('[data-chevron]', btn);
        if (chev) chev.classList.toggle('rotate-180', !expanded);
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  /* ------------------------------------------------------------- drawers */
  function Drawer(root) {
    this.root = root;
    this.overlay = $('.on-drawer__overlay', root);
    var self = this;
    on(this.overlay, 'click', function () { self.close(); });
    $$('[data-drawer-close]', root).forEach(function (b) {
      on(b, 'click', function () { self.close(); });
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) self.close();
    });
  }
  Drawer.prototype.open = function () {
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var focusable = $('[data-drawer-focus]', this.root);
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  };
  Drawer.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  };

  var cartDrawer = null;
  var searchDrawer = null;

  /* ---------------------------------------------------------------- cart */
  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      var previous = parseInt(el.textContent, 10) || 0;
      el.textContent = count;
      el.hidden = count === 0;
      if (count > previous) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;               // restart the animation
        el.classList.add('is-bumped');
      }
    });
  }

  /* ------------------------------------------------ add-to-cart feedback */
  var STATES = ['idle', 'loading', 'success', 'error'];

  function setAtcState(button, state) {
    if (!button) return;
    button.setAttribute('data-atc-state', state);

    STATES.forEach(function (s) {
      var icon = $('[data-atc-icon="' + s + '"]', button);
      if (icon) icon.hidden = s !== state;
    });

    var label = $('[data-atc-label]', button);
    if (label) {
      if (state === 'loading') {
        label.textContent = Strings.adding || 'Adding...';
      } else if (state === 'success') {
        label.textContent = Strings.added || 'Added';
      } else if (state === 'idle') {
        label.textContent = button.getAttribute('data-label-default') || Strings.addToCart;
      }
    }

    button.disabled = state === 'loading';
    if (state === 'loading') {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  function announce(message) {
    var region = $('[data-atc-status]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 30);
  }

  var toastTimer = null;
  function toast(message, isError) {
    var el = $('[data-toast]');
    if (!el) {
      if (isError) window.alert(message);
      return;
    }
    el.textContent = message;
    el.classList.toggle('on-toast--error', !!isError);
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () { el.hidden = true; }, 250);
    }, 3200);
  }

  function renderCart(cart) {
    setCartCount(cart.item_count);

    var body = $('[data-cart-drawer-body]');
    var foot = $('[data-cart-drawer-foot]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<p class="text-sm text-neutral-600">' + (Strings.cartEmpty || 'Your cart is empty') + '</p>' +
        '<a href="' + (Routes.root || '/') + 'collections/all" class="on-btn mt-6">Continue shopping</a>';
      if (foot) foot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item, index) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '';
      html +=
        '<div class="on-cart-line" data-line="' + (index + 1) + '">' +
          '<a class="on-cart-line__media" href="' + item.url + '">' + img + '</a>' +
          '<div class="min-w-0">' +
            '<a href="' + item.url + '" class="text-sm font-medium text-black">' + escapeHtml(item.product_title) + '</a>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="mt-0.5 text-xs text-neutral-500">' + escapeHtml(item.variant_title) + '</p>' : '') +
            (item.selling_plan_allocation
              ? '<p class="mt-0.5 text-xs text-neutral-500">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</p>' : '') +
            '<div class="mt-3 flex items-center justify-between gap-3">' +
              '<div class="on-qty">' +
                '<button type="button" data-line-minus aria-label="Decrease quantity">&minus;</button>' +
                '<input type="number" min="0" value="' + item.quantity + '" data-line-qty aria-label="Quantity">' +
                '<button type="button" data-line-plus aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="text-sm">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="on-cart-line__remove mt-2" data-line-remove>' + (Strings.removeItem || 'Remove') + '</button>' +
          '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    if (foot) {
      foot.hidden = false;
      var subtotal = $('[data-cart-subtotal]', foot);
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fetchCart() {
    return fetch((Routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch((Routes.cart_change || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return cart;
      });
  }

  function addToCart(formData, button, form) {
    setAtcState(button, 'loading');

    var scopedError = form ? $('[data-atc-error]', form.closest('[data-product-root]') || form) : null;
    if (scopedError) scopedError.hidden = true;

    var isJson = formData && typeof FormData !== 'undefined' && !(formData instanceof FormData);
    var headers = isJson
      ? { 'Content-Type': 'application/json', Accept: 'application/json' }
      : { Accept: 'application/json' };

    return fetch((Routes.cart_add || '/cart/add') + '.js', {
      method: 'POST',
      headers: headers,
      body: isJson ? JSON.stringify(formData) : formData
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Add to cart failed');
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        setAtcState(button, 'success');
        announce(Strings.addedAnnounce || Strings.added || 'Added to cart');
        if (window.ONDebug && cart.items && cart.items.length) {
          var last = cart.items[cart.items.length - 1];
          console.log('[theme] cart line:', last.product_title, '| variant:', last.variant_title,
                      '| selling plan:',
                      last.selling_plan_allocation
                        ? last.selling_plan_allocation.selling_plan.name
                        : 'NONE (one-time)');
        }

        // Hold the confirmed state briefly so the click is clearly acknowledged
        // even when the drawer opens over it.
        window.setTimeout(function () { setAtcState(button, 'idle'); }, 1800);

        if (ThemeSettings.cartDrawer !== false && cartDrawer) {
          cartDrawer.open();
        } else {
          toast(Strings.added || 'Added to cart', false);
        }
        return cart;
      })
      .catch(function (err) {
        setAtcState(button, 'error');
        announce(err.message);
        if (scopedError) {
          scopedError.textContent = err.message;
          scopedError.hidden = false;
        } else {
          toast(err.message, true);
        }
        window.setTimeout(function () { setAtcState(button, 'idle'); }, 2200);
      });
  }

  /* Build the add-to-cart payload directly from the checked card.

     Subscription apps ship storefront scripts that manage `selling_plan`
     themselves; when a theme uses custom purchase UI rather than the app's own
     widget, those scripts can clear the hidden input and the URL param. Posting
     JSON built from the DOM state we control means nothing in between can strip
     the plan off the request. */
  function buildProductPayload(form) {
    var root = form.closest('[data-product-root]');
    if (!root) return null;
    var checked = $('[data-variant-option][aria-checked="true"]', root);
    if (!checked) return null;

    var qtyInput = $('input[name="quantity"]', form);
    var item = {
      id: parseInt(checked.getAttribute('data-variant-option'), 10),
      quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1
    };
    var planId = checked.getAttribute('data-selling-plan');
    if (planId) item.selling_plan = parseInt(planId, 10);

    if (window.ONDebug) console.log('[theme] add to cart payload', item);
    return { items: [item] };
  }

  /* Re-assert the selected variant and selling plan straight from the checked
     card immediately before submitting. Subscription apps inject their own
     storefront scripts that can rewrite the URL or the hidden inputs after a
     variant change; this makes the visually-selected card authoritative. */
  function syncSellingPlan(form) {
    var root = form.closest('[data-product-root]');
    if (!root) return;
    var checked = $('[data-variant-option][aria-checked="true"]', root);
    if (!checked) return;

    var idInput = $('[data-variant-id]', form);
    var planInput = $('[data-selling-plan-input]', form);
    var planId = checked.getAttribute('data-selling-plan') || '';

    if (idInput) idInput.value = checked.getAttribute('data-variant-option');
    if (planInput) {
      planInput.value = planId;
      planInput.disabled = planId === '';   // omit the param entirely for one-time
    }
  }

  var cartDelegated = false;
  function initCart() {
    var root = $('[data-cart-drawer]');
    if (root && once(root)) cartDrawer = new Drawer(root);

    $$('[data-cart-open]').forEach(function (btn) {
      if (!once(btn)) return;
      on(btn, 'click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        if (cartDrawer) { cartDrawer.open(); fetchCart().then(renderCart); }
      });
    });

    // Delegated line-item controls (drawer + cart page share the hooks)
    if (!cartDelegated) {
      cartDelegated = true;
    on(document, 'click', function (e) {
      var line = e.target.closest('[data-line]');
      if (!line) return;
      var idx = line.getAttribute('data-line');
      var input = $('[data-line-qty]', line);

      if (e.target.closest('[data-line-remove]')) {
        e.preventDefault();
        changeLine(idx, 0);
      } else if (e.target.closest('[data-line-plus]')) {
        e.preventDefault();
        changeLine(idx, parseInt(input.value, 10) + 1);
      } else if (e.target.closest('[data-line-minus]')) {
        e.preventDefault();
        changeLine(idx, Math.max(0, parseInt(input.value, 10) - 1));
      }
    });

    on(document, 'change', function (e) {
      var line = e.target.closest('[data-line]');
      if (line && e.target.matches('[data-line-qty]')) {
        changeLine(line.getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });
    }

    // AJAX add-to-cart for every product form on the page
    $$('form[action*="/cart/add"]').forEach(function (form) {
      if (!once(form)) return;
      on(form, 'submit', function (e) {
        e.preventDefault();
        syncSellingPlan(form);
        var payload = buildProductPayload(form) || new FormData(form);
        addToCart(payload, $('[data-atc-button]', form) || $('[type="submit"]', form), form);
      });
    });

    fetchCart().then(function (cart) { setCartCount(cart.item_count); renderCart(cart); });
  }

  /* ------------------------------------------------- predictive search */
  function initSearch() {
    var root = $('[data-search-drawer]');
    if (!root) return;
    if (once(root)) searchDrawer = new Drawer(root);

    $$('[data-search-open]').forEach(function (btn) {
      if (!once(btn)) return;
      on(btn, 'click', function (e) { e.preventDefault(); searchDrawer.open(); });
    });

    var input = $('[data-predictive-input]', root);
    var results = $('[data-predictive-results]', root);
    if (!input || !results || !once(input)) return;

    var timer = null;
    var controller = null;

    on(input, 'input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (controller) controller.abort();
      if (q.length < 2) { results.innerHTML = ''; return; }

      timer = window.setTimeout(function () {
        controller = new AbortController();
        var url = (Routes.predictive_search || '/search/suggest')
          + '?q=' + encodeURIComponent(q)
          + '&resources[type]=product,article,page,collection'
          + '&resources[limit]=6'
          + '&section_id=predictive-search';

        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { /* aborted */ });
      }, 220);
    });
  }

  /* ----------------------------------------------------------- accordions */
  function initAccordions() {
    $$('[data-accordion]').forEach(function (group) {
      var single = group.getAttribute('data-accordion') === 'single';
      $$('[data-acc-trigger]', group).forEach(function (trigger) {
        var item = trigger.closest('.on-acc');
        if (!once(trigger)) return;
        on(trigger, 'click', function () {
          var isOpen = item.classList.contains('is-open');
          if (single) {
            $$('.on-acc', group).forEach(function (other) {
              if (other !== item) {
                other.classList.remove('is-open');
                var t = $('[data-acc-trigger]', other);
                if (t) t.setAttribute('aria-expanded', 'false');
                swapAccIcon(other, false);
              }
            });
          }
          item.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', String(!isOpen));
          swapAccIcon(item, !isOpen);
        });
      });
    });
  }

  function swapAccIcon(item, isOpen) {
    var plus = $('[data-acc-icon="plus"]', item);
    var minus = $('[data-acc-icon="minus"]', item);
    if (plus) plus.hidden = isOpen;
    if (minus) minus.hidden = !isOpen;
  }

  /* ------------------------------------------------------ qty steppers */
  function initQtySteppers() {
    $$('[data-qty]').forEach(function (wrap) {
      if (!once(wrap)) return;
      var input = $('input', wrap);
      on($('[data-qty-minus]', wrap), 'click', function () {
        input.value = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      on($('[data-qty-plus]', wrap), 'click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* -------------------------------------------- product variant selection */
  function initProductForms() {
    $$('[data-product-root]').forEach(function (root) {
      if (!once(root)) return;
      var variants = [];
      var payload = $('[data-product-variants]', root);
      if (payload) { try { variants = JSON.parse(payload.textContent); } catch (e) { variants = []; } }

      var idInput = $('[data-variant-id]', root);
      var submit = $('[data-atc-button]', root);
      var priceEl = $('[data-variant-price]', root);
      var compareEl = $('[data-variant-compare]', root);

      var planInput = $('[data-selling-plan-input]', root);

      function findVariant(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      // `card` is optional. When present its data attributes win, because a
      // selling-plan allocation has its own price that the variant JSON
      // payload knows nothing about.
      function select(id, card) {
        var variant = findVariant(id);
        // Only a card knows which plan it represents. When select() is
        // called without one (e.g. a variant <select>), keep whatever plan is
        // already chosen rather than silently dropping the subscription.
        var planId = card
          ? (card.getAttribute('data-selling-plan') || '')
          : (planInput ? planInput.value : '');

        if (idInput) idInput.value = id;
        if (planInput) planInput.value = planId;

        var price = card && card.getAttribute('data-price')
          ? parseInt(card.getAttribute('data-price'), 10)
          : (variant ? variant.price : null);
        var compare = card && card.getAttribute('data-compare')
          ? parseInt(card.getAttribute('data-compare'), 10)
          : (variant ? variant.compare_at_price : 0);

        $$('[data-variant-option]', root).forEach(function (el) {
          var active = el === card;
          if (!card) {
            active = String(el.getAttribute('data-variant-option')) === String(id);
          }
          el.setAttribute('aria-checked', String(active));
          el.classList.toggle('border-black', active);
          el.classList.toggle('bg-neutral-50', active);
          el.classList.toggle('border-black/15', !active);
          el.classList.toggle('bg-transparent', !active);
          var dot = $('[data-variant-dot]', el);
          if (dot) dot.hidden = !active;
          var ring = $('[data-variant-ring]', el);
          if (ring) {
            ring.classList.toggle('border-black', active);
            ring.classList.toggle('border-black/40', !active);
          }
        });

        if (priceEl && price !== null) priceEl.textContent = formatMoney(price);
        if (compareEl) {
          if (compare && price !== null && compare > price) {
            compareEl.textContent = formatMoney(compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (submit) {
          var available = variant ? variant.available : true;
          submit.disabled = !available;
          var label = $('[data-atc-label]', submit) || submit;
          label.textContent = available
            ? (submit.getAttribute('data-label-default') || Strings.addToCart)
            : Strings.soldOut;
        }

        if (variant && variant.featured_media_id) showMedia(root, variant.featured_media_id);

        if (window.history.replaceState && root.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          if (planId) {
            url.searchParams.set('selling_plan', planId);
          } else {
            url.searchParams.delete('selling_plan');
          }
          window.history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-variant-option]', root).forEach(function (card) {
        on(card, 'click', function (e) { e.preventDefault(); select(card.getAttribute('data-variant-option'), card); });
      });
      $$('[data-variant-select]', root).forEach(function (sel) {
        on(sel, 'change', function () { select(sel.value); });
      });

      // Boot from whichever card the template marked as checked, so the
      // selling plan is carried over rather than reset to variant-only.
      var checked = $('[data-variant-option][aria-checked="true"]', root);
      if (checked) {
        select(checked.getAttribute('data-variant-option'), checked);
      } else if (idInput && idInput.value) {
        select(idInput.value);
      }
    });
  }

  function showMedia(root, mediaId) {
    var main = $$('[data-media-id]', root);
    if (!main.length) return;
    main.forEach(function (m) { m.hidden = m.getAttribute('data-media-id') !== String(mediaId); });
    $$('[data-media-thumb]', root).forEach(function (t) {
      t.setAttribute('aria-current', String(t.getAttribute('data-media-thumb') === String(mediaId)));
    });
  }

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      $$('[data-media-thumb]', gallery).forEach(function (thumb) {
        if (!once(thumb)) return;
        on(thumb, 'click', function (e) {
          e.preventDefault();
          showMedia(gallery.closest('[data-product-root]') || gallery, thumb.getAttribute('data-media-thumb'));
        });
      });
    });
  }

  /* --------------------------------------------------------- carousels */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (root) {
      if (!once(root)) return;
      var slides = $$('[data-carousel-slide]', root);
      if (slides.length < 2) return;
      var index = 0;
      var counter = $('[data-carousel-index]', root);
      var progress = $('[data-carousel-progress]', root);
      var dots = $$('[data-carousel-dot]', root);

      function render() {
        slides.forEach(function (s, i) { s.hidden = i !== index; });
        if (counter) counter.textContent = index + 1;
        if (progress) progress.style.width = ((index + 1) / slides.length * 100) + '%';
        dots.forEach(function (d, i) {
          d.classList.toggle('bg-black', i === index);
          d.classList.toggle('bg-black/20', i !== index);
        });
      }
      // Slides may each carry their own prev/next chrome (the review spotlight
      // duplicates the controls inside every slide), so bind every match.
      $$('[data-carousel-prev]', root).forEach(function (btn) {
        on(btn, 'click', function () { index = (index - 1 + slides.length) % slides.length; render(); });
      });
      $$('[data-carousel-next]', root).forEach(function (btn) {
        on(btn, 'click', function () { index = (index + 1) % slides.length; render(); });
      });
      dots.forEach(function (d, i) { on(d, 'click', function () { index = i; render(); }); });
      render();
    });
  }

  /* -------------------------------------------------------------- tabs */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      if (!once(root)) return;
      var triggers = $$('[data-tab-trigger]', root);
      var panels = $$('[data-tab-panel]', root);
      if (triggers.length < 2) return;

      function activate(key) {
        triggers.forEach(function (t) {
          var active = t.getAttribute('data-tab-trigger') === key;
          t.setAttribute('aria-selected', String(active));
          t.classList.toggle('rounded-full', active);
          t.classList.toggle('bg-white', active);
          t.classList.toggle('px-5', active);
          t.classList.toggle('py-2.5', active);
          t.classList.toggle('shadow-sm', active);
          t.classList.toggle('sm:px-6', active);
          t.classList.toggle('text-neutral-600', active);
          t.classList.toggle('text-neutral-500', !active);
          t.classList.toggle('cursor-pointer', !active);
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
      }

      triggers.forEach(function (t) {
        on(t, 'click', function () { activate(t.getAttribute('data-tab-trigger')); });
      });
      activate(triggers[0].getAttribute('data-tab-trigger'));
    });
  }

  /* ------------------------------------------- horizontal scroll arrows */
  function initScrollers() {
    $$('[data-scroller]').forEach(function (root) {
      if (!once(root)) return;
      var track = $('[data-scroller-track]', root);
      if (!track) return;
      function step(dir) {
        var card = track.firstElementChild;
        var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      on($('[data-scroller-prev]', root), 'click', function () { step(-1); });
      on($('[data-scroller-next]', root), 'click', function () { step(1); });
    });
  }

  /* ------------------------------------------------ sticky scroll stacks
     Reproduces the 200vh / 300vh sticky sections: as the tall wrapper
     scrolls past, the active slide advances. */
  function initStickyStacks() {
    var stacks = $$('[data-sticky-stack]');
    if (!stacks.length) return;

    function update() {
      stacks.forEach(function (stack) {
        var slides = $$('[data-stack-slide]', stack);
        if (!slides.length) return;
        var rect = stack.getBoundingClientRect();
        var travel = rect.height - window.innerHeight;
        var progress = travel > 0 ? Math.min(1, Math.max(0, -rect.top / travel)) : 0;
        var index = Math.min(slides.length - 1, Math.floor(progress * slides.length));
        if (stack.__index === index) return;
        stack.__index = index;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        $$('[data-stack-dot]', stack).forEach(function (d, i) {
          d.classList.toggle('bg-black', i === index);
          d.classList.toggle('bg-black/20', i !== index);
        });
        var counter = $('[data-stack-index]', stack);
        if (counter) counter.textContent = ('0' + (index + 1)).slice(-2);
        var prev = $('[data-stack-prev]', stack);
        var next = $('[data-stack-next]', stack);
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      });
    }

    // Manual arrows scroll the window to the matching slice of the tall wrapper.
    stacks.forEach(function (stack) {
      if (!once(stack)) return;
      var slides = $$('[data-stack-slide]', stack);
      function goTo(i) {
        var travel = stack.offsetHeight - window.innerHeight;
        var target = stack.offsetTop + travel * ((i + 0.5) / slides.length);
        window.scrollTo({ top: target, behavior: 'smooth' });
      }
      on($('[data-stack-prev]', stack), 'click', function () { goTo(Math.max(0, (stack.__index || 0) - 1)); });
      on($('[data-stack-next]', stack), 'click', function () { goTo(Math.min(slides.length - 1, (stack.__index || 0) + 1)); });
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* --------------------------------------------------- scroll reveal */
  function initReveal() {
    var els = $$('.on-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------ nitric-oxide canvas animation
     Ported 1:1 from the source bundle so the Flow "science" panel animates
     exactly as it did on the static site. */
  function initNitricOxideCanvas() {
    $$('[data-no-canvas]').forEach(function (canvas) {
      if (!once(canvas)) return;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var steps = $$('[data-no-step]', canvas.closest('[data-no-diagram]') || document);

      var W = 700, H = 200;
      canvas.width = W; canvas.height = H;

      var TEAL = '#215056';
      var TEAL_DARK = '#183b40';
      var PHASE = 3000;
      var narrow = { top: 86, bot: 114 };
      var wide = { top: 32, bot: 168 };
      var ease = function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; };

      function bounds(phase, t) {
        if (phase === 0) return { top: narrow.top, bot: narrow.bot };
        if (phase === 1) {
          var e = ease(t);
          return {
            top: narrow.top + (wide.top - narrow.top) * e,
            bot: narrow.bot + (wide.bot - narrow.bot) * e
          };
        }
        return { top: wide.top, bot: wide.bot };
      }

      var cells = [];
      for (var i = 0; i < 18; i++) {
        cells.push({
          x: Math.random() * W,
          yFrac: Math.random(),
          rx: 10 + Math.random() * 5,
          ry: 0,
          color: Math.random() > 0.5 ? '#c0392b' : '#a93226'
        });
      }
      var pops = [];
      for (var j = 0; j < 6; j++) {
        pops.push({
          x: (W / 7) * (j + 1) + (Math.random() - 0.5) * 40,
          yFrac: 0.2 + Math.random() * 0.6,
          popAt: j * 0.12
        });
      }
      var arrowsX = [W * 0.2, W * 0.5, W * 0.8];

      function drawArrows(x, y, scale, alpha) {
        if (alpha <= 0) return;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.strokeStyle = TEAL;
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        var len = 22 * scale;
        ctx.beginPath(); ctx.moveTo(x, y - 6); ctx.lineTo(x, y - 6 - len); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(x - 8, y - 6 - len + 10); ctx.lineTo(x, y - 6 - len); ctx.lineTo(x + 8, y - 6 - len + 10);
        ctx.stroke();
        ctx.beginPath(); ctx.moveTo(x, y + 6); ctx.lineTo(x, y + 6 + len); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(x - 8, y + 6 + len - 10); ctx.lineTo(x, y + 6 + len); ctx.lineTo(x + 8, y + 6 + len - 10);
        ctx.stroke();
        ctx.restore();
      }

      var start = null;
      var lastPhase = -1;
      var raf = null;

      function frame(now) {
        if (start === null) start = now;
        var elapsed = (now - start) % (PHASE * 3);
        var phase = Math.floor(elapsed / PHASE);
        var t = (elapsed % PHASE) / PHASE;

        if (phase !== lastPhase) {
          lastPhase = phase;
          steps.forEach(function (el, idx) {
            el.style.opacity = idx === phase ? '1' : '0';
            el.style.transform = idx === phase ? 'translateY(0)' : 'translateY(6px)';
          });
        }

        var b = bounds(phase, t);
        var height = b.bot - b.top;
        var mid = (b.top + b.bot) / 2;

        ctx.fillStyle = '#F5F4F5'; ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = '#d9d9d9';
        ctx.fillRect(0, 0, W, b.top);
        ctx.fillRect(0, b.bot, W, H - b.bot);
        ctx.fillStyle = '#eceae8';
        ctx.fillRect(0, b.top, W, height);

        ctx.save();
        ctx.beginPath(); ctx.rect(0, b.top + 1, W, height - 2); ctx.clip();
        var speed = phase === 2 ? 1.4 : 0.5;
        cells.forEach(function (cell) {
          cell.ry = cell.rx * 0.46;
          var y = b.top + cell.ry + cell.yFrac * Math.max(0, height - cell.ry * 2);
          if (y - cell.ry >= b.top && y + cell.ry <= b.bot) {
            ctx.beginPath(); ctx.ellipse(cell.x, y, cell.rx, cell.ry, 0, 0, Math.PI * 2);
            ctx.fillStyle = cell.color; ctx.fill();
            ctx.strokeStyle = 'rgba(80,0,0,0.2)'; ctx.lineWidth = 0.8; ctx.stroke();
            ctx.beginPath(); ctx.ellipse(cell.x, y, cell.rx * 0.2, cell.ry * 0.32, 0, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(100,0,0,0.28)'; ctx.fill();
          }
          cell.x += speed;
          if (cell.x - cell.rx > W) { cell.x = -cell.rx; cell.yFrac = Math.random(); }
        });

        if (phase === 0) {
          pops.forEach(function (p) {
            if (t < p.popAt) return;
            var pt = Math.min(1, (t - p.popAt) / 0.08);
            var scale = pt < 0.6 ? ease(pt / 0.6) * 1.3 : 1.3 - ease((pt - 0.6) / 0.4) * 0.3;
            var y = b.top + p.yFrac * height;
            ctx.save();
            ctx.translate(p.x, y);
            ctx.scale(scale, scale);
            ctx.strokeStyle = 'rgba(255,255,255,0.85)';
            ctx.lineWidth = 3;
            ctx.beginPath(); ctx.moveTo(-9, 0); ctx.lineTo(9, 0); ctx.stroke();
            ctx.beginPath(); ctx.arc(-18, 0, 10, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(255,255,255,0.95)'; ctx.fill();
            ctx.font = 'bold 10px Manrope, sans-serif';
            ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            ctx.fillStyle = TEAL_DARK; ctx.fillText('N', -18, 0);
            ctx.beginPath(); ctx.arc(18, 0, 10, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(255,255,255,0.95)'; ctx.fill();
            ctx.fillStyle = TEAL_DARK; ctx.fillText('O', 18, 0);
            ctx.restore();
          });
        }
        ctx.restore();

        if (phase === 1) {
          var alpha = Math.min(1, t * 3) * (1 - Math.max(0, (t - 0.7) * 3));
          var scale2 = ease(t);
          arrowsX.forEach(function (x) { drawArrows(x, mid, scale2, alpha); });
        }

        raf = window.requestAnimationFrame(frame);
      }

      // Only animate while visible, to keep the page cheap.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && raf === null) {
              raf = window.requestAnimationFrame(frame);
            } else if (!entry.isIntersecting && raf !== null) {
              window.cancelAnimationFrame(raf); raf = null; start = null; lastPhase = -1;
            }
          });
        }, { threshold: 0.1 });
        io.observe(canvas);
      } else {
        raf = window.requestAnimationFrame(frame);
      }
    });
  }

  /* ---------------------------------------------------- country/province */
  function initAddressForms() {
    if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
    $$('[data-address-selectors]').forEach(function (wrap) {
      var country = $('[data-address-country]', wrap);
      var province = $('[data-address-province]', wrap);
      if (!country || !province) return;
      new window.Shopify.CountryProvinceSelector(country.id, province.id, {
        hideElement: province.getAttribute('data-province-container')
      });
    });
    $$('[data-address-toggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (target) target.hidden = !target.hidden;
      });
    });
  }

  /* --------------------------------------------------------- collection */
  function initFacets() {
    $$('[data-facet-form]').forEach(function (form) {
      if (!once(form)) return;
      $$('select, input[type="checkbox"]', form).forEach(function (field) {
        on(field, 'change', function () { form.submit(); });
      });
    });
  }

  /* ------------------------------------------------------------ boot */
  function boot() {
    // Each initialiser is isolated: a failure in one section must never take
    // down navigation, the cart or the rest of the page's interactivity.
    [initMobileMenu, initCart, initSearch, initAccordions, initQtySteppers,
     initProductForms, initGallery, initCarousels, initTabs, initScrollers,
     initStickyStacks, initReveal, initNitricOxideCanvas, initAddressForms,
     initFacets].forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        console.warn('theme.js: ' + (fn.name || 'initialiser') + ' failed', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-bind when the theme editor swaps a section.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();